module.exports = __webpack_public_path__ + "static/24-abstract-box-hexagon-arrows-1ed0601293b600e09e50e05d964020be.png";